import './publicPath'

const Vue = window.Vue

Vue.component('MultiCarousel', () => import( './components/Slider.vue'))
Vue.component('ButtonVideo', () => import( './components/ButtonVideo.vue'))
Vue.component('LazyVideoMw', () => import('./components/LazyVid.vue'))
Vue.component('CarouselSlider', () => import('./components/CarouselSlides.vue'))
Vue.component('GridCarouselContainer', () => import( './components/GridCarouselContainer.vue'))
Vue.component('PictureContainer', () => import('./components/Picture.vue'))
Vue.component('ItemGridCarousel', () => import('./components/Item/ItemGridCarousel.vue'))
Vue.component('Alert', () => import('./components/Alert.vue'))
Vue.component('LazyItemImage', () => import( './components/Item/LazyItemImage.vue'))


Vue.component('CustomAddToBasket', () => import('./components/Item/CustomAddToBasket.vue'))
Vue.component('CustomCategoryItem', () => import('./components/ItemList/CustomCategoryItem.vue'))
Vue.component('CustomCategoryItemData', () => import('./components/ItemList/CustomCategoryItemData.vue'))
Vue.component('CustomCategoryImage', () => import('./components/ItemList/CustomCategoryImage.vue'))
Vue.component('CustomUserLoginHandler', () => import('./components/customer/login/CustomUserLoginHandler.vue'))
Vue.component('FlexWrapperGrid', () => import('./components/FlexWrapperGrid.vue'))
Vue.component('SchedulerComponent', () => import('./components/SchedulerComponent.vue'))
Vue.component('IfnumberofitemsComponent', () => import('./components/IfNumberOfItemsComponent.vue'))
Vue.component('IfamountComponent', () => import('./components/IfAmountComponent.vue'))
Vue.component('CustomWishListCount', () => import('./components/wishList/CustomWishListCount.vue'))
Vue.component('IfdeliveryComponent', () => import('./components/IfDeliveryCountryComponent.vue'))
Vue.component('CustomItemSearch', () => import('./components/ItemList/CustomItemSearch.vue'))

import AccordionItem from "./components/AccordionItem.vue";
Vue.component('AccordionItem', AccordionItem)
Vue.component('LogoImage', () => import('./components/LogoImage.vue'))
Vue.component('ExpandContainer', () => import('./components/ExpanderContainer.vue'))
Vue.component('FlexElement', () => import('./components/FlexElement.vue'))
Vue.component('ResponsiveContainer', () => import('./components/ResponsiveContainer.vue'))
Vue.component('IfmanufacturerComponent', () => import('./components/IfManufacturerComponent.vue'))
Vue.component('IfreferrerComponent', () => import('./components/IfReferrerComponent.vue'))
Vue.component('IfcategoryComponent', () => import('./components/IfCategoryComponent.vue'))
Vue.component('IfpropertyComponent', () => import('./components/IfPropertyComponent.vue'))

Vue.component('GuidedSearchCard', () => import('./components/GuidedSearchCard.vue'))

import AccordionElement from "./components/AccordionElement.vue";
Vue.component('AccordionElement', AccordionElement)

import AccordionItemFunctional from "./components/AccordionItemFunctional.vue";
Vue.component('AccordionItemFunctional', AccordionItemFunctional)

Vue.component('VariationSelectTable', () => import('./components/item/VariationSelectTable.vue'))
Vue.component('CustomStepByStepNavigation', () => import('./components/category/CustomStepByStepNavigation.vue'))

Vue.component('SwiperSliderBanner', () => import('./components/SwiperSliderBanner.vue'))

Vue.component('GridContainer', () => import('./components/GridContainer.vue'))